import Page from "webPage/Page";

Page.register('page-template-get-a-quote-form', () => {
    $(document).bind('gform_post_render', function () {
        let gfRecaptchaPoller = setInterval(function () {
            if (!window.grecaptcha || !window.grecaptcha.render) {
                return;
            }
            if ($('.ginput_recaptcha').length <= 0) {
                return;
            }
            setTimeout(function () {
                console.log("rerender recaptcha")
                renderRecaptcha();
                clearInterval(gfRecaptchaPoller);
            });
        }, 100);
    });
});
